/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable object-curly-newline */
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      id="contact"
      sx={{
        width: '100%', padding: '60px 0 20px 0', background: '#1A202C', color: '#fff',
      }}
    >
      <Box sx={{
        width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
      >
        <Box>
          <Typography sx={{
            fontWeight: '700', fontSize: { xs: '38px', sm: '40px' }, color: '##fff', margin: '10px 0',
          }}
          >
            Contact Us
          </Typography>
          <Box sx={{ width: '95%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', margin: '10px 0', gap: { xs: '12px', sm: '0' } }}>
            <Box sx={{ width: { xs: '100%', sm: '30%' }, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <LocationOnIcon />
              <Typography>12028 Nkwashi Estates, Lusaka-ZM</Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '30%' }, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <PhoneInTalkIcon />
              <Typography>+260 954 789 820 <br /> +260 971 099 052</Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '30%' }, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <EmailIcon />
              <Typography>sales@accessinmedia.com <br /> support@accessinmedia.com</Typography>
            </Box>
          </Box>
          <Button sx={{ margin: '20px 0' }} variant="contained" component="a" href="#pricing">Get Started Now</Button>
        </Box>
        <Box sx={{
          width: '100%', border: 'none', background: '#f9f9f9', margin: '30px 0',
        }}
        >
          <hr />
        </Box>
        <Box>
          <Typography sx={{ color: '#718096' }}>Accessin Media Connect Ltd &copy; 2022 | All Rights Reserved</Typography>
          <Typography sx={{ color: '#718096', cursor: 'pointer' }} onClick={() => navigate('/terms_and_conditions')}>Terms of Service</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
